import { request } from '@api/request'
import { FileType } from '@enums/FileType'
import { DownloadHelper } from '@helpers/DownloadHelper'
import { MediaDownloadRequestParams } from '@models/api/downloads/MediaDownloadRequestParams'
import { showToastError } from '@services/ToastService'
import { HttpStatusCode } from 'axios'
import { newI18n } from 'src/i18n'

const defaultParams: Partial<MediaDownloadRequestParams> = {
  hasCoastLine: true,
  hasAdministrativeBoundaries: true
}

const { t } = newI18n.global

export const media = {
  getMedia: async function (
    params: MediaDownloadRequestParams,
    downloadName: string
  ): Promise<File | undefined> {
    try {
      const paramsWithDefaults = { ...defaultParams, ...params }
      const response = await request.get<File | BlobPart>('media/getMedia', {
        params: paramsWithDefaults,
        responseType: 'blob'
      })
      const contentType = response.headers['content-type']
      if (response.status === HttpStatusCode.Ok) {
        if (contentType && contentType.includes('application/json')) {
          return response.data as File
        } else {
          DownloadHelper.downloadFile(
            response.data,
            downloadName,
            FileType.getMimeType(params.tipoArchivo),
            params.tipoArchivo
          )
        }
      } else {
        showToastError(t('error'), t('downloadFailedError'))
      }
    } catch (error) {
      showToastError(t('error'), t('downloadFailedError'))
    }
  }
}
